module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-37.ff619c5e.png";